import { TERMS } from "../../config/terminology";
import DisplayComments from "./DisplayComments";
import TableCellAdjustment from "./TableCellAdjustment";
import TableCellSafetyMargin from "./TableCellSafetyMargin";
import TableCellWeek1 from "./TableCellWeek1";
import TableCellWeek2 from "./TableCellWeek2";
import TableCellWeek3 from "./TableCellWeek3";
import TableCellWeek4 from "./TableCellWeek4";
import TableCellWeek5 from "./TableCellWeek5";
import { formatNumber } from "./defineUtils";
import CustomerTrustPopover from "./CustomerTrustPopover";
import CustomerTypePopover from "./CustomerTypePopover";
import SKUNamePopOver from "./SKUNamePopOver";
import SKUNumberPopOver from "./SKUNumberPopOver";
import { green, orange, red, grey, blue } from "@mui/material/colors";
import { Chip } from "@mui/material";
import Diversity2OutlinedIcon from '@mui/icons-material/Diversity2Outlined';
import TableCellTender from "./TableCellTender";

export const weeklyDepCols = [
   {
      field: "name",
      headerName: "Customer / CG ",
      hideSortIcons: "false",
      width: 120,
   },
   {
      field: "customerNumber",
      headerName: "Customer Number",
      hideSortIcons: "false",
      width: 100,
   },
   {
      field: "type",
      headerName: "Customer Type",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 120,
      renderHeader: (params) => {
         return <CustomerTypePopover />;
      },
   },
   {
      field: "skuName",
      headerName: "SKU / PG ",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      width: 120,
      renderHeader: (params) => {
         return <SKUNamePopOver />;
      },
   },
   {
      field: "skuNumb",
      headerName: "SKU Number",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      width: 110,
      renderHeader: (params) => {
         return <SKUNumberPopOver />;
      },
   },
   {
      field: "customerTrustLevel",
      headerName: "Relationship Level",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 140,
      align: "center",
      headerAlign: "center",
      renderHeader: (params) => {
         return <CustomerTrustPopover />;
      },
      renderCell: (params) => {
         return (
            <Chip
               sx={{ height: "1.8rem", minHeight: "1.8rem", padding: "0.5rem", }}
               //icon={<Diversity2OutlinedIcon sx={{ fontSize: 18, color: `${getChipProps(params).iconColor} !important` }}/>}
               {...getChipProps(params)}
            />
         );
      },
   },
   {
      field: "skuPercentage",
      headerName: "SKU Market Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      width: 70,
      // valueGetter: (params) => {
      //    return `${params.row.skuPercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "customerSharePercentage",
      headerName: "Cust Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      width: 70,
      // valueGetter: (params) => {
      //    return `${params.row.customerSharePercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "unusedQuota",
      headerName: `Unused ${TERMS.QUOTA} - Previous Period`,
      disableColumnMenu: false,
      filterable: true,
      width: 90,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
   {
      field: "initialQuota",
      headerName: `Initial ${TERMS.QUOTA}`,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
      renderHeader: (params) => {
         return (
           <span style={{ 
             display: 'flex', 
             justifyContent: 'center', 
             textAlign: 'center',
             whiteSpace: 'pre-wrap', 
             wordBreak: 'break-word', 
             lineHeight: 'normal',
             fontWeight : 600
           }}>
             {params.colDef.headerName}
           </span>
         );
     }
   },
   {
      field: "safetyMargin",
      headerName: "Safety margin %",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellSafetyMargin,
   },
   {
		field: "tender",
		headerName: "Tender",
		width: 100,
      align: "center",
      headerAlign: "center",
		renderCell: TableCellTender,
	},
   {
      field: "adjustment",
      headerName: "Adjustment",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellAdjustment,
   },
   {
      field: "quota",
      headerName: TERMS.QUOTA,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
   {
      field: "weekly1",
      headerName: "Week1",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellWeek1,
   },
   {
      field: "weekly2",
      headerName: "Week2",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellWeek2,
   },
   {
      field: "weekly3",
      headerName: "Week3",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellWeek3,
   },
   {
      field: "weekly4",
      headerName: "Week4",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellWeek4,
   },
   {
      field: "weekly5",
      headerName: "Week5",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellWeek5,
   },
   {
      field: "sit",
      headerName: "SIT",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      flex:1,
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
   {
      field: "customerQuotaComments",
      headerName: "Comments",
      align: "center",
      headerAlign: "center",
      width: 100,
      renderCell: DisplayComments
   },
];

export const biWeeklyDepCols = [
   {
      field: "name",
      headerName: "Customer / CG ",
      hideSortIcons: "false",
      width: 120,
   },
   {
      field: "customerNumber",
      headerName: "Customer Number",
      hideSortIcons: "false",
      width: 100,
   },
   {
      field: "type",
      headerName: "Customer Type",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 120,
      renderHeader: (params) => {
         return <CustomerTypePopover />;
      },
   },
   {
      field: "skuName",
      headerName: "SKU / PG ",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      width: 120,
      renderHeader: (params) => {
         return <SKUNamePopOver />;
      },
   },
   {
      field: "skuNumb",
      headerName: "SKU Number",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      width: 110,
      renderHeader: (params) => {
         return <SKUNumberPopOver />;
      },
   },
   {
      field: "customerTrustLevel",
      headerName: "Relationship Level",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 140,
      align: "center",
      headerAlign: "center",
      renderHeader: (params) => {
         return <CustomerTrustPopover />;
      },
      renderCell: (params) => {
         const chipProps = getChipProps(params);
         return (
            <Chip
               sx={{ height: "1.8rem", minHeight: "1.8rem", padding: "0.5rem", }}
               //icon={<Diversity2OutlinedIcon sx={{ fontSize: 18, color: `${getChipProps(params).iconColor} !important` }}/>}
               {...getChipProps(params)}
            />
         );
      },
   },
   {
      field: "skuPercentage",
      headerName: "SKU Market Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      width: 70,
      // valueGetter: (params) => {
      //    return `${params.row.skuPercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "customerSharePercentage",
      headerName: "Cust Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      width: 70,
      // valueGetter: (params) => {
      //    return `${params.row.customerSharePercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "unusedQuota",
      headerName: `Unused ${TERMS.QUOTA} - Previous Period`,
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      width: 90,
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
   {
      field: "initialQuota",
      headerName: `Initial ${TERMS.QUOTA}`,
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
      renderHeader: (params) => {
         return (
           <span style={{ 
             display: 'flex', 
             justifyContent: 'center', 
             textAlign: 'center',
             whiteSpace: 'pre-wrap', 
             wordBreak: 'break-word', 
             lineHeight: 'normal',
             fontWeight : 600
           }}>
             {params.colDef.headerName}
           </span>
         );
     }
   },
   {
      field: "safetyMargin",
      headerName: "Safety margin %",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellSafetyMargin,
   },
   {
		field: "tender",
		headerName: "Tender",
		width: 100,
      align: "center",
      headerAlign: "center",
		renderCell: TableCellTender,
	},
   {
      field: "adjustment",
      headerName: "Adjustment",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellAdjustment,

   },
   {
      field: "quota",
      headerName: TERMS.QUOTA,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },

   },
   {
      field: "weekly1",
      headerName: "First Half",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellWeek1,
   },
   {
      field: "weekly2",
      headerName: "Second Half",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellWeek2,
   },
   {
      field: "sit",
      headerName: "SIT",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      flex:1,
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
   {
      field: "customerQuotaComments",
      headerName: "Comments",
      align: "center",
      headerAlign: "center",
      width: 100,
      renderCell: DisplayComments
   },
];

export const noDepCols = [
   {
      field: "name",
      headerName: "Customer / CG ",
      hideSortIcons: "false",
      width: 120,
   },
   {
      field: "customerNumber",
      headerName: "Customer Number",
      hideSortIcons: "false",
      width: 100,
   },
   {
      field: "type",
      headerName: "Customer Type",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 120,
      renderHeader: (params) => {
         return <CustomerTypePopover />;
      },
   },
   {
      field: "skuName",
      headerName: "SKU / PG ",
      disableColumnMenu: false,
      filterable: true,
      width: 120,
      hideSortIcons: "false",
      renderHeader: (params) => {
         return <SKUNamePopOver />;
      },
   },
   {
      field: "skuNumb",
      headerName: "SKU Number",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      width: 110,
      renderHeader: (params) => {
         return <SKUNumberPopOver />;
      },
   },
   {
      field: "customerTrustLevel",
      headerName: "Relationship Level",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      align: "center",
      headerAlign: "center",
      width: 140,
      renderHeader: (params) => {
         return <CustomerTrustPopover />;
      },
      renderCell: (params) => {
         const chipProps = getChipProps(params);
         return (
            <Chip
               sx={{ height: "1.8rem", minHeight: "1.8rem", padding: "0.5rem", }}
               //icon={<Diversity2OutlinedIcon sx={{ fontSize: 18, color: `${getChipProps(params).iconColor} !important` }}/>}
               {...getChipProps(params)}
            />
         );
      },
   },
   {
      field: "skuPercentage",
      headerName: "SKU Market Share %",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      align: "center",
      headerAlign: "center",
      flex: 1,
      // valueGetter: (params) => {
      //    return `${params.row.skuPercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "customerSharePercentage",
      headerName: "Cust Share %",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      align: "center",
      headerAlign: "center",
      flex: 1,
      // valueGetter: (params) => {
      //    return `${params.row.customerSharePercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "unusedQuota",
      headerName: `Unused ${TERMS.QUOTA} - Previous Period`,
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
   {
      field: "initialQuota",
      headerName: `Initial ${TERMS.QUOTA}`,
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      align: "center",
      flex: 1,
      headerAlign: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
      renderHeader: (params) => {
         return (
           <span style={{ 
             display: 'flex', 
             justifyContent: 'center', 
             textAlign: 'center',
             whiteSpace: 'pre-wrap', 
             wordBreak: 'break-word', 
             lineHeight: 'normal',
             fontWeight : 600
           }}>
             {params.colDef.headerName}
           </span>
         );
     }
   },
   {
      field: "safetyMargin",
      headerName: "Safety margin %",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellSafetyMargin,
   },
   {
		field: "tender",
		headerName: "Tender",
		width: 100,
      align: "center",
      headerAlign: "center",
		renderCell: TableCellTender,
	},
   {
      field: "adjustment",
      headerName: "Adjustment",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellAdjustment,
   },
   {
      field: "quota",
      headerName: TERMS.QUOTA,
      align: "center",
      flex: 1.25,
      headerAlign: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
   {
      field: "sit",
      headerName: "SIT",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      align: "center",
      headerAlign: "center",
      flex: 0.85,
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
   {
      field: "customerQuotaComments",
      headerName: "Comments",
      align: "center",
      headerAlign: "center",
      width: 100,
      renderCell: DisplayComments
   },
];

export const summaryView = [
   {
      field: "name",
      headerName: "Customer / CG ",
      flex: 2,
   },
   {
      field: "customerNumber",
      headerName: "Customer Number",
      flex: 1,
   },
   {
      field: "skuName",
      headerName: "SKU / PG ",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      flex: 2,
      renderHeader: (params) => {
         return <SKUNamePopOver />;
      },
   },
   {
      field: "skuNumb",
      headerName: "SKU Number",
      disableColumnMenu: false,
      filterable: true,
      hideSortIcons: "false",
      flex: 1,
      renderHeader: (params) => {
         return <SKUNumberPopOver />;
      },
   },
   {
      field: "customerSharePercentage",
      headerName: "Cust Share %",
      disableColumnMenu: false,
      filterable: true,
      align: "center",
      headerAlign: "center",
      hideSortIcons: "false",
      flex: 1,
      // valueGetter: (params) => {
      //    return `${params.row.customerSharePercentage}%`;
      // },
      valueParser: (value) => parseFloat(value.replace('%', '')),
      valueFormatter: ({ value }) => `${value}%`,
      sortComparator: (v1, v2, param1, param2) => parseFloat(v1) - parseFloat(v2),
   },
   {
      field: "safetyMargin",
      headerName: "Safety margin %",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: TableCellSafetyMargin,
   },
   {
		field: "tender",
		headerName: "Tender",
		width: 100,
      align: "center",
      headerAlign: "center",
		renderCell: TableCellTender,
	},
   {
      field: "adjustment",
      headerName: "Adjustment",
      flex: 1,
      align: "center",
      headerAlign: "center",
      headeralign: "center",
      headerAlign: "center",
      renderCell: TableCellAdjustment,
   },
   {
      field: "quota",
      headerName: TERMS.QUOTA,
      flex: 1,
      align: "center",
      headerAlign: "center",
      headeralign: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
         const formattedValue = params.value?.toLocaleString('en-US');
         return formattedValue;
      },
   },
];

function getChipProps(params) {
   if (params.value === "Low") {
      return {
         label: "Low",
         style: {
            fontWeight: "bold",
            //borderColor: green[500],
            backgroundColor: red[50],
            color: red[500],
         },
         iconColor: red[500],
      };
   } else if (params.value === "Medium") {
      return {
         label: "Medium",
         style: {
            fontWeight: "bold",
            //borderColor: orange[500],
            backgroundColor: orange[50],
            color: orange[500],
         },
         iconColor: orange[500],
      };
   } else if (params.value === "High") {
      return {
         label: "High",
         style: {
            fontWeight: "bold",
            //borderColor: green[500],
            backgroundColor: green[50],
            color: green[500],
         },
         iconColor: green[500],
      };
   } else if (params.value === "Severe") {
      return {
         label: "Severe",
         style: {
            fontWeight: "bold",
            //borderColor: grey[500],
            backgroundColor: grey[50],
            color: grey[500],
         },
         iconColor: grey[500],
      };
   } else {
      return {
         label: "Other",
         style: {
            fontWeight: "bold",
            //borderColor: blue[500],
            backgroundColor: blue[50],
            color: blue[500],
         },
         iconColor: blue[500],
      };
   }
}